/**
 * A full-document exit the trainer chose: signing out, the landing after an erased account, the
 * payment provider's page, Google's consent page. Every such exit goes through `leaveDocument`, so a
 * guard that asks before unsaved work is lost (`useBlocker` with `enableBeforeUnload`) can tell the
 * app's own exit from a reload or a closed tab, and stand aside for it.
 *
 * Without this, the installed `@tanstack/history` answers `beforeunload` for EVERY navigation while a
 * blocker is registered, including `window.location.assign`. „Stay" then left the trainer signed out
 * on `/konto`, or with a purchase button busy for good.
 *
 * The intent is module state because the exit and the guard live in different slices; it ends with
 * the document. The one way the document survives an exit is the back/forward cache, so a page
 * restored from it starts guarded again.
 */

let leaving = false;
let restoreListened = false;

export function leaveDocument(url: string): void {
  leaving = true;
  if (!restoreListened) {
    restoreListened = true;
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) leaving = false;
    });
  }
  window.location.assign(url);
}

/** Whether the app has started a full-document exit the trainer chose. */
export function isLeavingDocument(): boolean {
  return leaving;
}
